var lib_core = require("lib-core");

var PropertyInstanceData = function(template){
    lib_core.AbstractInstance.call(this);

    this.val = this.value("value", true);    // take care to not overwrite this.value from versions.js
    this.prefix = this.value("prefix", true);

    if (template) { // template is only given when constructing this persistent instance for the first time not during dejsonify, TODO: this is maybe not the best / cleanest way to determine this
        if(template.defaultValue() != null) this.val(template.defaultValue());
        if(template.defaultPrefix() != null) this.prefix(template.defaultPrefix());
    }
};
lib_core.inherit(PropertyInstanceData, lib_core.AbstractInstance);
lib_core.JsonParser.registerClass(PropertyInstanceData, "PropertyInstanceData");

module.exports = PropertyInstanceData;

PropertyInstanceData.prototype.initialize = function () {
    var componentInstance = this.parent();
};

PropertyInstanceData.prototype.getUnit = function () {
    var unit = this.template.unit();
    if (unit.toLowerCase() == 'ohm') unit = '\u2126';   // TODO: do we want to convert ohm symbol here?
    if (this.template.isFixedUnit()) return unit;
    else return this.prefix().replace('none','') + unit;
};
